import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

// Écran chargé à la demande : le portail client et la connexion n'en téléchargent pas le code.
const NewEntryScreen = lazy(() => import('../screens/NewEntryScreen.js'));

/** Nouvelle entrée (espace garage). */
export default function NewEntryPage() {
  return (
    <GarageGate>
      <NewEntryScreen />
    </GarageGate>
  );
}
